import { gql } from "@apollo/client";

export const GET_PARTICIPATION_DETAIL = gql`
  query GetParticipationDetail($participationId: Int!) {
    participation(participationId: $participationId) {
      id
      userId
      user {
        id
        name
        phone
      }
      campaignRunId
      status
      joinedAt
      completedAt
      depositAmount
      prizeAmount
      depositChargeId
      run {
        id
        startAt
        endAt
        durationMinutes
        note
        depositAmount
        prizeAmount
        campaign {
          id
          brandId
          brand {
            id
            name
          }
          channel
          productName
          category
          originalPrice
          discountPrice
          paybackPrice
          discountRate
          photoReviewRequired
          productImageUrl
          productUrl
          isPublished
          steps {
            id
            stepOrder
            type
            title
            guide
            requirements
            notices
            proofType
            isRequired
            meta
          }
          runs {
            id
            startAt
            endAt
          }
        }
      }
      submissions {
        id
        participationId
        missionStepId
        stepOrder
        windowStartAt
        windowEndAt
        isSubmitted
        isApproved
        status
        submittedAt
        reviewedAt
        approvedAt
        rejectedAt
        reviewerAccountId
        proofType
        proofData
        note
        step {
          id
          stepOrder
          type
          title
          guide
          requirements
          notices
          proofType
          isRequired
          meta
          imageUrl
        }
      }
    }
  }
`;

export const SUBMIT_MISSION_SUBMISSION = gql`
  mutation SubmitMissionSubmission(
    $submissionId: Int!
    $proofData: Json!
    $imageFile: Upload
  ) {
    submitMissionSubmission(
      submissionId: $submissionId
      proofData: $proofData
      imageFile: $imageFile
    ) {
      success
      message
      submission {
        id
        status
        submittedAt
        proofData
      }
    }
  }
`;
